export default {
  auth_error: {
    status: "error",
    text: "Authorisation Error",
  },
  login: {
    status: "warning",
    text: "Log in to the system",
  },
  "no projects": {
    status: "warning",
    text: "You don't have projects yet.",
  },
  "no tasks": {
    status: "warning",
    text: "You don't have tasks yet.",
  },
  other: {
    status: "error",
    text: "Something went wrong.",
  },
  warning: {
    status: "warning",
    text: "Something went wrong.",
  },
  "no comments": {
    status: "warning",
    text: "You don't have comments yet.",
  },
  success: {
    status: "success",
    text: "The action was successful.",
  },
  "no key_message": {
    status: "error",
    text: "We are experiencing issues. We are working on it, please try again a bit later",
  },
  "file length": {
    status: "warning",
    text: "files cannot be more than 5.",
  },
};
